import axios from "axios";

import Appointment from "./Appointment.ts";

class Api {
  appointment;

  constructor() {
    this.appointment = Appointment(this);
  }
  post(path: string, params: any, data: any) {
    return this.send(path, "POST", params, data);
  }

  put(path: string, params: any, data: any) {
    return this.send(path, "PUT", params, data);
  }

  get(path: string, params: any, data: any) {
    return this.send(path, "GET", params, data);
  }

  delete(path: string, params: any, data: any) {
    return this.send(path, "DELETE", params, data);
  }

  patch(path: string, params: any, data: any) {
    return this.send(path, "PATCH", params, data);
  }
  send(path: string, method: any, params: any, data: any) {
    const baseUrl = process.env.REACT_APP_KMS_BASE_URL;
    const url = `${baseUrl}/${path}`;
    const tok = localStorage.getItem("token");

    return new Promise(async (resolve, reject) => {
      const headers: Record<string, string> = {
        "Content-Type":
          data instanceof FormData ? "multipart/form-data" : "application/json",
        Accept: "application/json",
      };
      if (tok) {
        headers.token = `${tok}`;
      }
      if (data instanceof FormData) {
        for (let [key, value] of data.entries()) {
          console.log(`${key}: ${value}`);
        }
      }

      const axiosArgs = Object.entries({
        url,
        method,
        headers,
        params,
        data,
      })
        .filter((entry) => {
          const value = entry[1];
          const isEmptyObject =
            value != null &&
            typeof value === "object" &&
            Object.keys(value).length === 0;
          return !isEmptyObject;
        })
        .reduce((acc, entry) => {
          const [key, value] = entry;
          return { ...acc, [key]: value };
        }, {});
      axios(axiosArgs)
        .then((response) => {
          return resolve(response.data);
        })
        .catch((error) => {
          if (error.response) {
            const errorMessage =
              error.response.data.errors || error.response.data.base || error.response.data;
            return reject(createError("Error from server", errorMessage));
          } else if (error.request) {
            reject(createError("No Response from server", error.request));
          } else {
            reject(createError("Error processing request", error.message));
          }
        });
    });
  }
}

function formatErrorMessage(errorResponse: any): string {
  if (errorResponse?.error) {
    return errorResponse.error;
  }

  const errors = errorResponse?.errors || errorResponse?.base || errorResponse;

  if (typeof errors === "string") {
    // Case: errors is a simple string
    return errors;
  }

  if (Array.isArray(errors)) {
    // Case: errors is an array of messages (strings or mixed)
    return errors
        .map((item) =>
            typeof item === "string" ? item : JSON.stringify(item)
        )
        .join(", ");
  }

  if (typeof errors === "object" && errors !== null) {
    // Case: errors is a key-value object
    const formattedErrors: string[] = [];

    for (const key in errors) {
      if (Object.prototype.hasOwnProperty.call(errors, key)) {
        let formattedKey = key.split("_").join(" ");
        formattedKey =
            formattedKey.charAt(0).toUpperCase() + formattedKey.slice(1);

        const value = errors[key];

        let message = "";
        if (Array.isArray(value)) {
          message = value.join(" ");
        } else if (typeof value === "string") {
          message = value;
        } else {
          message = JSON.stringify(value);
        }

        formattedErrors.push(`${formattedKey} ${message}`);
      }
    }

    return formattedErrors.join(", ");
  }

  // Fallback for anything unexpected
  return JSON.stringify(errors);
}

function createError(name: string, message: string) {
  const error = new Error();
  error.name = name;
  error.message = formatErrorMessage(message);
  return error;
}

function handleErrorMessage(errorMessage: any) {
  if (typeof errorMessage === "string") {
    console.log("errorMessage===>", errorMessage);
  } else if (Array.isArray(errorMessage)) {
    const arrayErrors = errorMessage.map((message) => message).join(", ");
    console.log("arrayErrors===>", arrayErrors);
  } else if (typeof errorMessage === "object" && errorMessage !== null) {
    const fieldErrors: string[] = [];
    for (const [field, messages] of Object.entries(errorMessage)) {
      if (Array.isArray(messages)) {
        messages.forEach((message) => {
          fieldErrors.push(`${field}: ${message}`);
        });
      } else {
        fieldErrors.push(`${field}: ${messages}`);
      }
    }
    console.log("fieldErrors===>", fieldErrors.join(", "));
  } else {
    console.log("errorMessage===>", errorMessage);
  }
}

export default new Api();
